import { CommonModule } from '@angular/common';
import { Component, computed, input, model, output } from '@angular/core';

import { TableFieldComponent } from '@module-definition/table-field/table-field.component';
import { WeatherTableFieldComponent } from '@module-definition/weather-table-field/weather-table-field.component';
import { CipoControlComponent } from '@shared/components/fields/cipo-control/cipo-control.component';
import { CipoFieldConfig, CipoFieldTypes, CipoForm } from '@shared/components/fields/common';
import { FroalaConfig } from '@shared/components/froala/common';
import { FroalaComponent } from '@shared/components/froala/froala.component';
import { CipoFroalaOptions } from '@shared/components/froala/interfaces/options.type';

@Component({
  selector: 'cipo-grid-form',
  imports: [CommonModule, FroalaComponent, CipoControlComponent, TableFieldComponent, WeatherTableFieldComponent],
  templateUrl: './grid-form.component.html',
  styleUrls: ['./grid-form.component.scss'],
})
export class GridFormComponent {
  readonly FIELD_TYPES = CipoFieldTypes;
  form = input.required<CipoForm>();
  /** Emitted when a control is blurred. Emits the control's key */
  onBlur = output<string>();
  fieldsData = model<Record<string, CipoFieldConfig>>({});
  /** List of field IDs to be displayed in the grid. Based on this input the fields are arranged in the grid.
   * If not provided, the order will be keys ascending */
  fieldIds = input<string[]>([]);

  keys = computed(() => {
    return this.fieldIds().length ? this.fieldIds() : Object.keys(this.form().controls);
  });

  /* Calculates the Froala options (heightMax) for each rich text field based on its configuration (rows saved in definition) */
  froalaOptionsDict = computed(() => {
    const fieldsData = this.fieldsData();
    return Object.keys(fieldsData).reduce(
      (acc, key) => {
        const field = fieldsData[key];
        if (field.type === CipoFieldTypes.RichText) {
          acc[key] = {
            ...FroalaConfig.inline,
            heightMax: (field.position?.rows || 1) * 50 || 200,
          };
        }
        return acc;
      },
      {} as Record<string, CipoFroalaOptions>,
    );
  });
}
